/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_2_SolutionInputs */

const et_portfolio_project_2_solution = /** @type {(inputs: Portfolio_Project_2_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehitasime veebilehe nullist, lõime selge brändiidentiteedi ja rakendasime päringutele suunatud turundussüsteemi.`)
};

const en_portfolio_project_2_solution = /** @type {(inputs: Portfolio_Project_2_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebuilt the website from scratch, created a clear brand identity, and implemented a lead-focused marketing system.`)
};

/**
* | output |
* | --- |
* | "Rebuilt the website from scratch, created a clear brand identity, and implemented a lead-focused marketing system." |
*
* @param {Portfolio_Project_2_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_2_solution = /** @type {((inputs?: Portfolio_Project_2_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_2_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_2_solution(inputs)
	return en_portfolio_project_2_solution(inputs)
});